import { render, staticRenderFns } from "./ListTaxonomySelector.vue?vue&type=template&id=2e2497b5&scoped=true&"
import script from "./ListTaxonomySelector.vue?vue&type=script&lang=js&"
export * from "./ListTaxonomySelector.vue?vue&type=script&lang=js&"
import style0 from "./ListTaxonomySelector.vue?vue&type=style&index=0&id=2e2497b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2497b5",
  null
  
)

export default component.exports